import { c as _c } from "react/compiler-runtime";
import React from 'react';
const DesktopMenuSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="ml-auto hidden animate-pulse items-center gap-4 lg:flex">{Array.from(Array(7).keys()).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DesktopMenuSkeleton;
function _temp(index) {
  return <div key={index} className="bg-text-secondary h-5 w-16 rounded-sm" />;
}